module.exports = __webpack_public_path__ + "files/7881c475e2b08eeeafd244389b50369f.png";